import vv_utils from './vv_utils';
import { simpleInvokeMachine, fullInvokeMachine, fullLoadingInvokeMachine } from "./vv_api";
import validateEmail from './email-validator';
import requestWebAuthn from './vv_webauthn';
import setupTotp from './vv_totp';
import { redirectRequest } from './vv_c';

const settingsInit_onStart = () => {
  const tenant = window.vv_tenant_data;

  //Accordions
  const passwordAccordion = document.getElementById("password-accordion");
  const socialAccordion = document.getElementById("social-accordion");
  const fidoAccordion = document.getElementById("fido-accordion");
  const totpAccordion = document.getElementById("totp-accordion");

  const { interpret } = window.XState;

  //Alertboxs
  const profileAlertbox = document.getElementById("profile-alert");
  const credAlertbox = document.getElementById("credAlert");

  //FieldMaps
  const profileFieldFormMap = {
    'profileEmail': '#profileEmail',
    'profileName': '#profileName'
  }

  const passwordFieldFormMap = {
    'password': '#password',
  }

  const verificationcodeFieldFormMap = {
    'code': '#verificationcode',
  }

  const issuerMap = {
    'https://accounts.google.com': 'Google',
    'https://login.microsoftonline.com': 'Microsoft',
    'https://appleid.apple.com': 'Apple'
  }

  //used as a catch-all to allow button elements to submit a form without the ACTION
  function formSubmit(e) {
    if (e.preventDefault) e.preventDefault();
  }

  //Buttons
  const vvPasswordUpdateBtn = document.getElementById("vvPasswordUpdateBtn");
  const vvPasswordAddBtn = document.getElementById("vvPasswordAddBtn");
  const vvPasswordRemoveBtn = document.getElementById("vvPasswordRemoveBtn");
  const vvSessionResetBtn = document.getElementById("session-reset-btn");

  ///////////////////////////

  //shared confirmation modal
  const confirmModalBS = new window.bootstrap.Modal(document.getElementById("vv-confirm-modal"), {});
  const confirmBtn = document.getElementById("confirmModalBtn");

  //objects that implement 'Event', meaning they have a handleEvent method
  //this is assigned later dynamically
  let confirmHandler = {
    handleEvent(event) { }
  }
  let cancelHandler = {
    handleEvent(event) { }
  }

  confirmBtn.addEventListener("click", confirmHandler);
  document.getElementById("close-confirm").addEventListener("click", cancelHandler);

  function confirmAction(id, type, okCB, cancelCB) {
    
    
    
    if (type === "fido-enable") {
      document.getElementById("confirmText").innerText = "Are you sure you want to enable this credential?";
    } else if (type === "fido-disable") {
      document.getElementById("confirmText").innerText = "Are you sure you want to disable this credential?";
    } else if (type === "totp-enable") {
      document.getElementById("confirmText").innerText = "Are you sure you want to enable this Authenticator?";
    } else if (type === "totp-disable") {
      document.getElementById("confirmText").innerText = "Are you sure you want to disable this Authenticator?";
    } else if (type === "session-reset") {
      document.getElementById("confirmText").innerText = "Would you like to reset your current login sessions? NOTE: This will log you out now. Other devices may still have local sessions that will logout after expiration.";
    } else if (type === "email") {
      document.getElementById("confirmText").innerText = `Are you sure you want to update this email to ${id} ?`;
    } else {
      document.getElementById("confirmText").innerText = "Are you sure you want to delete this credential?";
    }

    confirmBtn.setAttribute("data-submission-type", type);
    confirmBtn.setAttribute("data-id", id);
    //eslint-disable-next-line
    confirmHandler.handleEvent = function (event) { okCB(event); confirmModalBS.hide(); };
    //eslint-disable-next-line
    cancelHandler.handleEvent = function (event) { cancelCB(event); confirmModalBS.hide(); };

    confirmModalBS.show();
  }

  ///////////////////////////

  //Load Data Service
  let profileState = {};
  let socialAlertText = "";
  let socialAlertType = "";

  function readInboundQueryResult() {
    //Inbound query string codes  
    const urlparams = new URLSearchParams(window.location.search);
    const code = urlparams.get('error');
    const socialConnectResponse = urlparams.get('social_connect');

    //open accordion if there is a social_connect Repsonse
    if (socialConnectResponse) {
      const collapseSocial = document.getElementById('collapseSocial')
      //const bsCollapse = new window.bootstrap.Collapse(socialAccordion);
      collapseSocial.classList.add("show");

      //some error with OIDC, display error and open social accordion
      if (socialConnectResponse.toLowerCase() === 'error') {

        if (code && vv_utils.messageMap[code]) {
          socialAlertText = vv_utils.messageMap[code];
        } else {
          socialAlertText = "There was an unexpected error adding the social identity";
        }
        socialAlertType = "danger";

      } else if (socialConnectResponse.toLowerCase() === 'success') {
        //Normal flow, display a success on the social alert and open accordion
        socialAlertText = "The social identity was added successfully";
        socialAlertType = "primary";

      } else {
        vv_utils.logError(new Error("Unknown social_connect: " + socialConnectResponse));
      }
    }
  }

  function showAndResetInboundQueryAlert() {
    if (socialAlertText && socialAlertType) {
      vv_utils.showalert(socialAlertText, socialAlertType, credAlertbox);
    }
    socialAlertText = "";
    socialAlertType = "";
  }

  function checkValidity(context, event) {
    return new Promise((resolve, reject) => {
      
      let valid = true;

      if (valid) {
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }
    })
  }

  function getCreds(context, event) {
    
    //return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/credentials?error=social3`, {}, 'GET', vv_utils.defaultTimeout);
    //return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/credentials?error=social`, {}, 'GET',vv_utils.defaultTimeout);
    //return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/credentials?error=none`, {}, 'GET',vv_utils.defaultTimeout);
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/credentials`, {}, 'GET',vv_utils.defaultTimeout);
  }

  function getProfile(context, event) {
    
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/profile`, {}, 'GET', vv_utils.defaultTimeout);
  }

  function loadData(context, event) {
    showAndResetInboundQueryAlert();
    return Promise.all([getCreds(context, event), getProfile(context, event)]);
  }

  //this is assigned later
  let createFidoTable = () => { }
  let createSocialTable = () => { }
  let createTotpTable = () => { }


  function createProfile(data) {
    document.getElementById("profileName").value = data.name ? data.name : "" ;
    document.getElementById("profileEmail").value = data.email;
  }

  const dataLoadService = interpret(
    fullInvokeMachine.withConfig({
      actions: {
        loading: () => {
          readInboundQueryResult();
        },
        loaded: () => {
          
        },
        message: (context, event) => {
          //vv_utils.clearInputValidation(form);
          vv_utils.clearalert(profileAlertbox);
          vv_utils.clearalert(credAlertbox);
        },
        validationFailed: () => {
          vv_utils.showalert("There are validation errors, fix fields highlighted in red and submit again.", "danger", profileAlertbox);
        },
        validationSucceeded: () => {
          dataLoadService.send("PERFORM_ACTION");
        },
        actionFailed: (context, event) => {
          
          vv_utils.logError(context.error);
          vv_utils.showStateErrors("There was an unexpected error", context.error, profileAlertbox);
        },
        actionSucceeded: (context, event) => {
          const jsonResponse = context.data;
          profileState = jsonResponse[1] ? jsonResponse[1] : {};
          //eslint-disable-next-line
          let fidoList = jsonResponse[0].data ? jsonResponse[0].data.filter((cred) => cred.type === "v1auth.WebauthnCredential") : [];
          let socialList = jsonResponse[0].data ? jsonResponse[0].data.filter((cred) => cred.type === "v1auth.SocialCredential") : [];
          let totpList = jsonResponse[0].data ? jsonResponse[0].data.filter((cred) => cred.type === "v1auth.TotpCredential") : [];
          
          
          
          //eslint-disable-next-line
          let passwordData = jsonResponse[0].data ? jsonResponse[0].data.filter((cred) => cred.type === "v1auth.PasswordCredential") : [];

          if (passwordData[0] && passwordData[0].id.toLowerCase() === "password") {
            document.getElementById("password-updated-at").innerText = new Date(passwordData[0].updated_at).toLocaleDateString();
            document.querySelector(".password-add-section").classList.add("d-none");
            document.getElementById("password-type").innerText = "Password last updated on:";
            document.querySelector("#vvPasswordUpdateBtn").classList.remove("d-none");
            document.querySelector("#vvPasswordRemoveBtn").classList.remove("d-none");
          } else {
            document.querySelector(".password-add-section").classList.remove("d-none");
            document.getElementById("password-type").innerText = "No password registerd, click 'New' to set a password";
            document.getElementById("password-updated-at").innerText = "";
            document.querySelector("#vvPasswordUpdateBtn").classList.add("d-none");
            document.querySelector("#vvPasswordRemoveBtn").classList.add("d-none");
          }
          createSocialTable(socialList);
          createFidoTable(fidoList);
          createTotpTable(totpList);
          createProfile(jsonResponse[1] ? jsonResponse[1] : {});
          dataLoadService.send("LOAD_COMPLETE");
        }
      },
      services: {
        validate_service: (context, event) => checkValidity(context, event),
        action_service: (context, event) => { return loadData(context, event) }
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  dataLoadService.send("LOAD_COMPLETE");
  dataLoadService.send("SUBMIT");

  ///////////////////////////

  //ModalEdit - FIDO rename
  const vvModalEditAlert = document.getElementById("vvModalEditAlert");
  const vvModalEdit = document.getElementById("vvModalEdit");
  const vvModalEditForm = document.getElementById("vvModalEditForm");
  const vvModalEditHeader = document.getElementById("vvModalEditHeader");
  const vvModalEditText = document.getElementById("vvModalEditText");
  const vvModalEditFeedback = document.getElementById("vvModalEditFeedback");
  const vvModalEditBtn = document.getElementById("vvModalEditBtn");

  let modalEditBS = new window.bootstrap.Modal(document.getElementById("vvModalEdit"), {});

  //FIDO rename
  function checkCredValidity(context, event) {
    return new Promise((resolve, reject) => {
      
      let valid = true;

      
      
      
      
      let nameElement = document.getElementById("vvModalEditText");
      if (nameElement.value.length <= 255) {
        //
      } else {
        vv_utils.makeInvalid(nameElement);
        valid = false;
      }

      if (valid) {
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }
    })
  }

  function loadCred(context, event) {
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/credentials/${event.id}`, {}, 'GET', vv_utils.defaultTimeout);
  }

  function updateCred(context, event) {
    
    
    
    
    let updatestate = context.data;
    updatestate.friendly_name = document.getElementById("vvModalEditText").value;
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/credentials/${event.id}`, updatestate, 'POST', vv_utils.defaultTimeout);
  }

  const credService = interpret(
    fullLoadingInvokeMachine.withConfig({
      actions: {
        loaded: (context, event) => {
          
          document.getElementById("vvModalEditText").value = context.data.friendly_name ? context.data.friendly_name : "";
          vv_utils.clearInputValidation(vvModalEditForm);
          vv_utils.clearalert(vvModalEditAlert);
          vv_utils.clearalert(credAlertbox);
        },
        message: (context, event) => {
          vv_utils.clearInputValidation(vvModalEditForm);
          vv_utils.clearalert(vvModalEditAlert);
          vv_utils.clearalert(credAlertbox);
        },
        validationFailed: () => {
          vv_utils.showalert("There are validation errors, fix fields highlighted in red and submit again.", "danger", vvModalEditAlert);
        },
        validationSucceeded: (context, event) => {
          
          
          
          credService.send("PERFORM_ACTION", { "id": context.data.id, });
        },
        actionFailed: (context, event) => {
          
          //TODO make this for cred object not password
          if (context.error && context.error.fields) {  
            vv_utils.highlightFields(context.error.fields, passwordFieldFormMap);
          }
          if (context.error) {  
            vv_utils.logError(context.error);
            vv_utils.showStateErrors("There was an unexpected error", context.error, vvModalEditAlert);
          }
        },
        actionSucceeded: (context, event) => {
          vv_utils.showalert("Updated successfully.", "primary", credAlertbox);
          modalEditBS.hide();
          
          //add a tiny delay to allow save to finish before modal showing
          dataLoadService.send("SUBMIT");
          credService.send("RE_INIT");
        }
      },
      services: {
        loading_service: (context, event) => loadCred(context, event),
        validate_service: (context, event) => checkCredValidity(context, event),
        action_service: (context, event) => { return updateCred(context, event) }
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  vv_utils.AttachAndSendFormEventsToMachineService(vvModalEditForm, credService, 'input', 'input');
  vv_utils.addFormAndMachineServiceChangeAndInputHandlers(vvModalEditForm, credService, formSubmit);

  vvModalEdit.addEventListener('hidden.bs.modal', function (event) {
    credService.send("RE_INIT");
  })



  ///////////////////////////

  //Credential Delete
  function removeCred(context, event) {
    
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/credentials/${event.id}`, {}, "DELETE");
  }

  const removeCredMachine = interpret(
    simpleInvokeMachine.withConfig({
      actions: {
        actionFailed: (context, event) => {
          vv_utils.logError(context.error);
          vv_utils.showStateErrors("There was an unexpected error", context.error, credAlertbox);
          confirmModalBS.hide();
          removeCredMachine.send("IDLE");
        },
        actionSucceeded: (context, event) => {
          
          let jsonResponse = context.data;
          let cred = jsonResponse.data ? [...jsonResponse.data] : [];
          confirmModalBS.hide();
          vv_utils.showalert("Removed successfully.", "primary", credAlertbox);
          removeCredMachine.send("IDLE");
          
          dataLoadService.send("SUBMIT");
        }
      },
      services: {
        //eslint-disable-next-line
        action_service: (context, event) => { return removeCred(context, event) }
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  ///////////////////////////

  //Reset Session
  function resetSession(context, event) {
    
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/sessions/clear`, {}, "POST");
  }

  const resetSessionMachine = interpret(
    simpleInvokeMachine.withConfig({
      actions: {
        actionFailed: (context, event) => {
          vv_utils.logError(context.error);
          vv_utils.showStateErrors("There was an unexpected error", context.error, credAlertbox);
          confirmModalBS.hide();
          resetSessionMachine.send("IDLE");
        },
        actionSucceeded: (context, event) => {
          
          let jsonResponse = context.data;
          let cred = jsonResponse.data ? [...jsonResponse.data] : [];
          confirmModalBS.hide();
          resetSessionMachine.send("IDLE");
          vv_utils.showalert("Session reset succeeded, now redirecting you to our login page.", "primary", credAlertbox);
          setTimeout( () => {window.location.assign("/login")} , 3000);  
          
        }
      },
      services: {
        //eslint-disable-next-line
        action_service: (context, event) => { return resetSession(context, event) }
      }
    })
  )
    .onTransition((state) => {  })
    .start();
  
  vvSessionResetBtn.addEventListener('click', () => {
    let id = "session-reset";
    confirmAction(id, "session-reset", (e) => {
      resetSessionMachine.send('FETCH', { 'id': id });
    }, (e) => { });
  })

  const vvSessionResetForm = document.getElementById("session-reset-form");
  vv_utils.addFormAndMachineServiceChangeAndInputHandlers(vvSessionResetForm, resetSessionMachine, formSubmit);
  ///////////////////////////


  //Cred disable/enable toggle - FIDO
  function toggleCredStatus(context, event) {
    
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/credentials/${event.id}/${event.status}`, {}, "POST");
  }

  function assignToggle(faIcon, on) {
    
    
    if (on) {
      //faIcon.setAttribute("data-icon", "toggle-on");
      faIcon.classList.remove("rotate-180");
      faIcon.classList.add("text-primary");
    } else {
      //faIcon.setAttribute("data-icon", "toggle-off");
      faIcon.classList.add("rotate-180");
      faIcon.classList.remove("text-primary");
      faIcon.setAttribute("data-icon", "toggle-off");
    }
  }

  const toggleCredMachine = interpret(
    simpleInvokeMachine.withConfig({
      actions: {
        actionFailed: (context, event) => {
          vv_utils.logError(context.error);
          vv_utils.showStateErrors("There was an unexpected error", context.error, credAlertbox);
        },
        actionSucceeded: (context, event) => {
          
          let selector = 'span.fa-toggle[data-fido-id="' + context.data.id + '"]';
          let icon = fidoAccordion.querySelectorAll(selector);
          
          
          
          
          
          
          assignToggle(icon[0].querySelector("svg"), !context.data.disabled);
          let jsonResponse = context.data;
          let cred = jsonResponse.data ? [...jsonResponse.data] : [];
          vv_utils.showalert("Updated successfully.", "primary", credAlertbox);
          toggleCredMachine.send("IDLE");
        }
      },
      services: {
        //eslint-disable-next-line
        action_service: (context, event) => { return toggleCredStatus(context, event) }
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  // function toggle(event) {
  //   const id = event.currentTarget.getAttribute('data-fido-id');
  //   let faIcon = event.currentTarget.getElementsByTagName("svg")[0];
  //   let on = !faIcon.classList.contains("rotate-180");
  //   
  //   confirmAction(id, on ? "fido-disable" : "fido-enable", (e) => {
  //     
  //     
  //     if (on) {
  //       toggleCredMachine.send("FETCH", { 'id': id, status: 'disable' });
  //     } else {
  //       toggleCredMachine.send("FETCH", { 'id': id, status: 'enable' });
  //     }
  //   }, (e) => { });
  // }

  ///////////////////////////

  //Modal Password Update
  const vvModalPasswordAlert = document.getElementById('vvModalPasswordAlert');
  const vvModalPassword = document.getElementById("vvModalPassword");
  const vvModalPasswordForm = document.getElementById("vvModalPasswordForm");
  const vvModalPasswordHeader = document.getElementById('vvModalPasswordHeader');
  const vvModalPasswordFeedback = document.getElementById('vvModalPasswordFeedback');
  const vvModalPasswordUpdateSaveBtn = document.getElementById('vvModalPasswordUpdateSaveBtn');

  const passwordModalBS = new window.bootstrap.Modal(document.getElementById('vvModalPassword'), {});

  //This had to be done manually instead of using bootstrap because we
  //added a custom 'eye' icon through a container div that did not allow for a 
  //feedback div directly under the input tag like normal
  function clearPasswordFeedback() {
    vvModalPasswordFeedback.style.display = 'none';
  }

  function checkPasswordValidity() {
    return new Promise((resolve, reject) => {
      
      let vvModalPasswordText = document.getElementById("split-password");
      let valid = true;

      //eslint-disable-next-line
      if (vvModalPasswordText.value && vvModalPasswordText.value.length >= 10 && vvModalPasswordText.value.length <= 255) {
        //
      } else {
        valid = false;
        vvModalPasswordFeedback.style.display = "block";
        vv_utils.makeInvalid(vvModalPasswordText);
      }

      if (valid) {
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }
    })
  }

  function updatePassword(context, event) {
    
    //in the future pass the password value through state machine 
    let password = document.getElementById('split-password').value;
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/password/update`, { "password": password }, "POST");
  }

  const updatePasswordMachine = interpret(
    fullInvokeMachine.withConfig({
      actions: {
        loaded: () => {
          
          vv_utils.clearalert(vvModalPasswordAlert);
          vv_utils.clearalert(credAlertbox);
        },
        message: (context, event) => {
          //
          vv_utils.clearInputValidation(vvModalPasswordForm);
          clearPasswordFeedback();
          vv_utils.clearalert(vvModalPasswordAlert);
          vv_utils.clearalert(credAlertbox);
          //vvModalPasswordFeedback.style.display = "none";
        },
        validationFailed: () => {
          vv_utils.showalert("There are validation errors, fix fields highlighted in red and submit again.", "danger", vvModalPasswordAlert);
        },
        validationSucceeded: () => {
          updatePasswordMachine.send("PERFORM_ACTION");
        },
        actionFailed: (context, event) => {
          if (context.error && context.error.fields) {  
            vv_utils.highlightFields(context.error.fields, passwordFieldFormMap);
          }
          if (context.error) {  
            vv_utils.logError(context.error);
            vv_utils.showStateErrors("There was an unexpected error", context.error, vvModalPasswordAlert);
          }
        },
        actionSucceeded: (context, event) => {          
          passwordModalBS.hide();
          dataLoadService.send("SUBMIT");
          //add a tiny delay to allow clears before modal showing
          setTimeout(function () {
            updatePasswordMachine.send("LOAD_COMPLETE");
          }, 2000);
          //add a tiny delay to allow the alert box to show before prompting confirm
          setTimeout(function () {
            confirmAction("session-reset", "session-reset", (e) => {
              resetSessionMachine.send('FETCH', { 'id': "session-reset" });
            }, (e) => { });
          }, 1100);          

          //show the success alert after the confirm modal is launched
          vv_utils.showalert("Updated successfully.", "primary", credAlertbox);
        }
      },
      services: {
        //eslint-disable-next-line
        validate_service: (context, event) => checkPasswordValidity(context, event),
        action_service: (context, event) => updatePassword(context, event)
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  //eslint-disable-next-line
  vv_utils.AttachAndSendFormEventsToMachineService(vvModalPasswordForm, updatePasswordMachine, 'input', 'input');
  //eslint-disable-next-line
  vv_utils.addFormAndMachineServiceChangeAndInputHandlers(vvModalPasswordForm, updatePasswordMachine, formSubmit);

  updatePasswordMachine.send("LOAD_COMPLETE");

  vvModalPassword.addEventListener('hidden.bs.modal', function (event) {
    //add a tiny delay to allow clears before modal showing
    setTimeout(function () {
      updatePasswordMachine.send("CHANGE");
      vvModalPasswordForm.reset();
    }, 2000);
  })

  vvModalPasswordUpdateSaveBtn.addEventListener('click', (e) => {
    e.preventDefault();
    updatePasswordMachine.send("SUBMIT");
  })

  vvPasswordUpdateBtn.addEventListener('click', () => {
    vvModalPasswordHeader.innerText = "Update Password";
    vvModalPasswordUpdateSaveBtn.innerText = "Update";
    passwordModalBS.show();
  })

  vvPasswordRemoveBtn.addEventListener('click', () => {
    let id = "password";
    confirmAction(id, "password", (e) => {
      removeCredMachine.send('FETCH', { 'id': id });
    }, (e) => { });
  })

  vvPasswordAddBtn.addEventListener('click', () => {
    passwordModalBS.show();
  })


  ///////////////////////////


  //Modal VerificationCode Update
  const vvModalVerifyCodeAlert = document.getElementById('vvModalVerifyCodeAlert');
  const vvModalVerifyCode = document.getElementById("vvModalVerifyCode");
  const vvModalVerifyCodeForm = document.getElementById("vvModalVerifyCodeForm");
  const vvModalVerifyCodeHeader = document.getElementById('vvModalVerifyCodeHeader');
  const vvModalVerifyCodeFeedback = document.getElementById('vvModalVerifyCodeFeedback');
  const vvModalVerifyCodeUpdateSaveBtn = document.getElementById('vvModalVerifyCodeUpdateSaveBtn');
  const vvModalVerifyCodeEmail = document.getElementById('vvModalVerifyCodeEmail');

  const verificationcodeModalBS = new window.bootstrap.Modal(document.getElementById('vvModalVerifyCode'), {});

  function checkVerificationCodeValidity() {
    return new Promise((resolve, reject) => {
      
      let vvModalVerifyCodeText = document.getElementById("verificationcode");
      let valid = true;

      //should be a 6 digit string
      //eslint-disable-next-line
      vvModalVerifyCodeText.value = vvModalVerifyCodeText.value.replace(/[^\d]+/g, '');
      if (vvModalVerifyCodeText.value && vvModalVerifyCodeText.value.length === 6 && /^\d+$/.test(vvModalVerifyCodeText.value)) {
        //
      } else {
        valid = false;
        vv_utils.makeInvalid(vvModalVerifyCodeText);
      }

      if (valid) {
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }
    })
  }

  function updateVerificationCode(context, event) {
    
    //in the future pass the verificationcode value through state machine 
    let verificationcode = document.getElementById('verificationcode').value;
    let profileEmail = document.getElementById("profileEmail").value;
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/email/update`, 
      { 
        "code": verificationcode, 
        "send": false, 
        "email": profileEmail,
      }, "POST");
  }

  const updateVerificationCodeMachine = interpret(
    fullInvokeMachine.withConfig({
      actions: {
        loaded: () => {
          
          vv_utils.clearalert(vvModalVerifyCodeAlert);
          vv_utils.clearalert(credAlertbox);
          vv_utils.clearalert(profileAlertbox);
        },
        message: (context, event) => {
          //
          vv_utils.clearInputValidation(vvModalVerifyCodeForm);
          vv_utils.clearalert(vvModalVerifyCodeAlert);
          vv_utils.clearalert(credAlertbox);
          vv_utils.clearalert(profileAlertbox);
          //vvModalVerifyCodeFeedback.style.display = "none";
        },
        validationFailed: () => {
          vv_utils.showalert("There are validation errors, fix fields highlighted in red and submit again.", "danger", vvModalVerifyCodeAlert);
        },
        validationSucceeded: () => {
          updateVerificationCodeMachine.send("PERFORM_ACTION");
        },
        actionFailed: (context, event) => {
          if (context.error && context.error.fields) {  
            vv_utils.highlightFields(context.error.fields, verificationcodeFieldFormMap);
          }
          if (context.error) {  
            vv_utils.logError(context.error);
            vv_utils.showStateErrors("There was an unexpected error", context.error, vvModalVerifyCodeAlert);
          }
        },
        actionSucceeded: (context, event) => {
          vv_utils.showalert("Updated successfully.", "primary", profileAlertbox);
          verificationcodeModalBS.hide();
          dataLoadService.send("SUBMIT");
          //add a tiny delay to allow clears before modal showing
          setTimeout(function () {
            updateVerificationCodeMachine.send("LOAD_COMPLETE");
          }, 2000);
        }
      },
      services: {
        //eslint-disable-next-line
        validate_service: (context, event) => checkVerificationCodeValidity(context, event),
        action_service: (context, event) => updateVerificationCode(context, event)
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  //eslint-disable-next-line
  vv_utils.AttachAndSendFormEventsToMachineService(vvModalVerifyCodeForm, updateVerificationCodeMachine, 'input', 'input');
  //eslint-disable-next-line
  vv_utils.addFormAndMachineServiceChangeAndInputHandlers(vvModalVerifyCodeForm, updateVerificationCodeMachine, formSubmit);

  updateVerificationCodeMachine.send("LOAD_COMPLETE");

  vvModalVerifyCode.addEventListener('hidden.bs.modal', function (event) {
    //add a tiny delay to allow clears before modal showing
    setTimeout(function () {
      updateVerificationCodeMachine.send("CHANGE");
      vvModalVerifyCodeForm.reset();
    }, 2000);
  })

  vvModalVerifyCode.addEventListener('show.bs.modal', function (event) {
    vvModalVerifyCodeEmail.innerText = document.getElementById("profileEmail").value;
  })

  vvModalVerifyCodeUpdateSaveBtn.addEventListener('click', (e) => {
    e.preventDefault();
    updateVerificationCodeMachine.send("SUBMIT");
  })

  ///////////////////////////


  //Name (named as profile)
  const userNameForm = document.getElementById("user-name-form");

  function checkNameValidity(context, event) {
    return new Promise((resolve, reject) => {
      
      let profileName = document.getElementById("profileName");
      let valid = true;
      if (profileName.value && (profileName.value.length <= 255)) {
        //
      } else {
        valid = false;
        vv_utils.makeInvalid(profileName);
      }
      if (valid) {
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }
    })
  }

  function updateName(context, event) {
    
    let profileName = document.getElementById("profileName");
    profileState.name = profileName.value;
    //eslist-disable-next-line
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/profile`, profileState, 'POST', vv_utils.defaultTimeout);
  }

  const nameService = interpret(
    fullInvokeMachine.withConfig({
      actions: {
        loaded: () => {
          
        },
        message: (context, event) => {
          vv_utils.clearInputValidation(userNameForm);
          vv_utils.clearalert(profileAlertbox);
          //needed for if user clicks into field after another action on a cred
          vv_utils.clearalert(credAlertbox);
        },
        validationFailed: (context, event) => {
          
          
          vv_utils.showalert("There are validation errors, fix fields highlighted in red and submit again.", "danger", profileAlertbox);
        },
        validationSucceeded: (context, event) => {
          
          
          //if was canceled go back to load_complete
          if (event.data === 'valid') {
            nameService.send("PERFORM_ACTION");
          } else {
            
            nameService.send("LOAD_COMPLETE");
          }
        },
        actionFailed: (context, event) => {
          if (context.error && context.error.fields) {  
            vv_utils.highlightFields(context.error.fields, profileFieldFormMap);
          }
          if (context.error) {  
            
            vv_utils.logError(context.error);
            vv_utils.showStateErrors("There was an unexpected error", context.error, profileAlertbox);
          }
        },
        actionSucceeded: (context, event) => {
          vv_utils.showalert("Updated successfully.", "primary", profileAlertbox);
          nameService.send("LOAD_COMPLETE");
        }
      },
      services: {
        validate_service: (context, event) => {
          //needed for when a prior cred action was done
          vv_utils.clearalert(credAlertbox);
          return checkNameValidity(context, event);
        },
        action_service: (context, event) => {
          return updateName(context, event);
        }
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  vv_utils.AttachAndSendFormEventsToMachineService(userNameForm, nameService, 'input', 'input');
  vv_utils.addFormAndMachineServiceChangeAndInputHandlers(userNameForm, nameService, formSubmit);

  nameService.send("LOAD_COMPLETE");

  ///////////////////////////

  //Email (named as profile)
  const userProfileForm = document.getElementById("user-profile-form");


  function checkEmailValidity(context, event) {
    return new Promise((resolve, reject) => {
      
      let profileEmail = document.getElementById("profileEmail");
      let valid = true;
      if (validateEmail(profileEmail.value)) {
        //
      } else {
        valid = false;
        vv_utils.makeInvalid(profileEmail);
      }
      if (valid) {
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }
    })
  }

  function updateEmail(context, event) {
    
    let profileEmail = document.getElementById("profileEmail");
    //eslist-disable-next-line
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/email/update`, { "email": profileEmail.value, "send":true }, 'POST', vv_utils.defaultTimeout);
  }

  const profileService = interpret(
    fullInvokeMachine.withConfig({
      actions: {
        loaded: () => {
          
        },
        message: (context, event) => {
          vv_utils.clearInputValidation(userProfileForm);
          vv_utils.clearalert(profileAlertbox);
          //needed for if user clicks into field after another action on a cred
          vv_utils.clearalert(credAlertbox);
        },
        validationFailed: (context, event) => {
          
          
          vv_utils.showalert("There are validation errors, fix fields highlighted in red and submit again.", "danger", profileAlertbox);
        },
        validationSucceeded: (context, event) => {
          
          
          //if was canceled go back to load_complete
          if (event.data === 'valid') {
            profileService.send("PERFORM_ACTION");
          } else {
            
            profileService.send("LOAD_COMPLETE");
          }
        },
        actionFailed: (context, event) => {
          if (context.error && context.error.fields) {  
            vv_utils.highlightFields(context.error.fields, profileFieldFormMap);
          }
          if (context.error) {  
            
            vv_utils.logError(context.error);
            vv_utils.showStateErrors("There was an unexpected error", context.error, profileAlertbox);
          }
        },
        actionSucceeded: (context, event) => {
          if (context.data && context.data.pending_verification) {
            verificationcodeModalBS.show();
            //vv_utils.showalert("The update is now pending verification of your new email address. Check your inbox for the confirmation instructions.", "info", profileAlertbox);
          } else {
            vv_utils.showalert("Updated successfully.", "primary", profileAlertbox);
          }
          profileService.send("LOAD_COMPLETE");
        }
      },
      services: {
        validate_service: (context, event) => {
          //needed for when a prior cred action was done
          vv_utils.clearalert(credAlertbox);
          return checkEmailValidity(context, event);
        },
        action_service: (context, event) => {
          return updateEmail(context, event);
        }
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  vv_utils.AttachAndSendFormEventsToMachineService(userProfileForm, profileService, 'input', 'input');
  vv_utils.addFormAndMachineServiceChangeAndInputHandlers(userProfileForm, profileService, formSubmit);

  profileService.send("LOAD_COMPLETE");



  ///////////////////////////

  class TableBuilder {
    constructor(pfx, title) {
      this.pfx = pfx;
      this.title = title;
    }

    build(creds) {
      
      const NAME_INDEX = 0;
      const EDIT_NAME_INDEX = 1;
      const CREATED_AT_INDEX = 2;
      const TOGGLE_INDEX = 3;
      const REMOVE_INDEX = 4;

      let tbody = document.getElementById(this.pfx + "-body");
      let fragment = document.createDocumentFragment();
      if (creds.length > 0) {
        creds.forEach((cred, index) => {
          let template = document.getElementById(this.pfx + "-template");
          
          let clone = template.content.cloneNode(true);
          let td = clone.querySelectorAll("td");
          this.tdName(td[NAME_INDEX], cred);
          this.tdEditName(td[EDIT_NAME_INDEX], cred);
          this.tdCreatedAt(td[CREATED_AT_INDEX], cred);
          this.tdToggle(td[TOGGLE_INDEX], cred);
          this.tdRemove(td[REMOVE_INDEX], cred, index);
          fragment.appendChild(clone);
        })
      } else {
        let tdBuilder = document.createElement("td");
        tdBuilder.classList.add("px-1");
        let heading6 = document.createElement("h6");
        heading6.classList.add("m-0");
        heading6.classList.add("fs--1");
        heading6.innerText = "No " + this.title + "s registered";
        tdBuilder.appendChild(heading6);
        fragment.appendChild(tdBuilder);
      }
      //TODO: look into doing a replace
      tbody.innerHTML = "";
      tbody.appendChild(fragment);
    }

    tdName(name, cred) {
      const esLintLittleBitchComplainer = this.pfx;
      if (cred.friendly_name) {
        name.querySelector('h6').innerText = cred.friendly_name;
      }
    }

    tdEditName(action, cred) {
      const actionElement = action.querySelector(".fa-edit-name");
      actionElement.setAttribute("data-" + this.pfx + "-id", `${cred.id}`);

      const pfx = this.pfx;
      const title = this.title;
      actionElement.addEventListener("click", (event) => {
        let id = event.currentTarget.getAttribute("data-" + pfx + "-id");

        credService.send("INIT_COMPLETE", { "id": id });
        vvModalEditHeader.innerText = "Rename " + title;
        let label = vvModalEdit.querySelectorAll('[for="vvModalEditText"]');
        label[0].innerText = title + " name";
        vvModalEditFeedback.innerText = "You must use a valid name smaller than 255";
        vvModalEditBtn.innerText = "Update";
        credService.send("CHANGE", { "id": id });
        //add a tiny delay to allow clears before modal showing
        setTimeout(function () {
          modalEditBS.show();
        }, 350);
        vvModalEditBtn.addEventListener("click", (e) => {
          credService.send("SUBMIT", { "id": id, "name": vvModalEditText.value });
        });
      });
    }

    tdCreatedAt(createdAt, cred) {

      const esLintLittleBitchComplainer = this.pfx;

      /* eslint-disable-next-line no-param-reassign */
      createdAt.querySelector('h6').innerText = new Date(cred.created_at).toLocaleDateString();
    }

    tdToggle(status, cred) {
      let icon = status.querySelector('.fa-toggle');
      icon.setAttribute("data-" + this.pfx + "-id", `${cred.id}`);
      assignToggle(icon.querySelector("svg"), !cred.disabled);

      const pfx = this.pfx;
      icon.addEventListener("click", (event) => {
        const id = event.currentTarget.getAttribute("data-" + pfx + "-id");
        let faIcon = event.currentTarget.getElementsByTagName("svg")[0];
        let on = !faIcon.classList.contains("rotate-180");
        

        const confirmState = on ? pfx + "-disable" : pfx + "-enable"
        confirmAction(id, confirmState, (e) => {
          
          
          if (on) {
            toggleCredMachine.send("FETCH", { 'id': id, status: 'disable' });
          } else {
            toggleCredMachine.send("FETCH", { 'id': id, status: 'enable' });
          }
        }, (e) => { });
      });
    }

    tdRemove(action, cred) {
      const removeLink = action.querySelector(".fa-trash");
      removeLink.setAttribute("data-" + this.pfx + "-id", `${cred.id}`);

      const pfx = this.pfx;
      removeLink.addEventListener("click", (event) => {
        let id = event.currentTarget.getAttribute("data-" + pfx + "-id");
        confirmAction(id, pfx, (e) => {
          removeCredMachine.send('FETCH', { 'id': id });
        }, (e) => { });
        return;
      });
    }
  }

  createTotpTable = (creds) => {
    const tbr = new TableBuilder("totp", "Authenticator");
    tbr.build(creds);
  }

  createFidoTable = (creds) => {
    const tbr = new TableBuilder("fido", "FIDO key");
    tbr.build(creds);
  }

  //social
  function addSocial(context, event) {
    
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/social/connect`, { "provider": event.provider }, "POST");
  }

  const addSocialMachine = interpret(
    simpleInvokeMachine.withConfig({
      actions: {
        actionFailed: (context, event) => {
          vv_utils.logError(context.error);
          vv_utils.showStateErrors("There was an unexpected error", context.error, profileAlertbox);
        },
        actionSucceeded: (context, event) => {
          
          const jsonResponse = window._.pick(context.data, Object.keys(redirectRequest));
          window.location.assign(jsonResponse.redirect);
          addSocialMachine.send("IDLE");
        }
      },
      services: {
        //eslint-disable-next-line
        action_service: (context, event) => { return addSocial(context, event) }
      }
    })
  )
    .onTransition((state) => {  })
    .start();


  function handleSocialRemove(event) {
    let id = event.currentTarget.getAttribute('data-social-id');
    confirmAction(id, "social", (e) => {
      removeCredMachine.send('FETCH', { 'id': id });
    }, (e) => { });

    return;
  }

  function tdSocialEmail(email, social) {
    if (social.claims && social.claims.email) {
      /* eslint-disable-next-line no-param-reassign */
      email.querySelector('h6').innerText = social.claims.email.replace("@", "\r\n@");
    }
  }
  function tdSocialName(name, social) {
    if (social.claims && social.claims.name) {
      /* eslint-disable-next-line no-param-reassign */
      name.querySelector('h6').innerText = social.claims.name;
    }
  }
  function tdSocialIssuer(issuer, social) {
    Object.keys(issuerMap).every(function (key) {
      if (social.issuer.startsWith(key)) {
        /* eslint-disable-next-line no-param-reassign */
        issuer.querySelector('h6').innerText = issuerMap[key];
        //return false to make every break;
        return false;
      }
      //return false to make every continue;
      return true;
    });
  }
  function tdSocialCreatedAt(createdAt, social) {
    /* eslint-disable-next-line no-param-reassign */
    createdAt.querySelector('h6').innerText = new Date(social.created_at).toLocaleDateString();
  }

  function tdSocialRemove(action, social) {
    const removeLink = action.querySelector(".fa-trash");

    removeLink.setAttribute("data-social-id", `${social.id}`);
    removeLink.addEventListener("click", handleSocialRemove);
  }

  createSocialTable = (socials) => {

    const EMAIL_INDEX = 0;
    const NAME_INDEX = 1;
    const ISSUER_INDEX = 2;
    const CREATED_AT_INDEX = 3;
    const REMOVE_INDEX = 4;

    let tbody = document.getElementById("social-body");
    let fragment = document.createDocumentFragment();
    if (socials.length > 0) {
      socials.forEach((social, index) => {
        let template = document.getElementById("social-template");
        let clone = template.content.cloneNode(true);
        let td = clone.querySelectorAll("td");

        tdSocialEmail(td[EMAIL_INDEX], social);
        tdSocialName(td[NAME_INDEX], social);
        tdSocialIssuer(td[ISSUER_INDEX], social);
        tdSocialCreatedAt(td[CREATED_AT_INDEX], social);
        tdSocialRemove(td[REMOVE_INDEX], social);
        fragment.appendChild(clone);
      })
    } else {
      let tdBuilder = document.createElement("td");
      tdBuilder.classList.add("px-1");
      let heading6 = document.createElement("h6");
      heading6.classList.add("m-0");
      heading6.classList.add("fs--1");
      heading6.innerText = "No Social Identities Registered";
      tdBuilder.appendChild(heading6);
      fragment.appendChild(tdBuilder);
    }
    tbody.innerHTML = "";
    tbody.appendChild(fragment);
  }

  ///////////////////////////

  // handles accordion show for social, fido and password
  if (tenant.allow_hardware) {
    fidoAccordion.classList.remove('d-none');
  }

  if (tenant.allow_social) {
    socialAccordion.classList.remove('d-none');
  }

  if (tenant.allow_passwords) {
    passwordAccordion.classList.remove('d-none');
  }

  if (tenant.allow_totp_app) {
    totpAccordion.classList.remove('d-none');
  }

  ///////////////////////////

  let addGoogleBtn = document.getElementById('add-google-btn');

  addGoogleBtn.addEventListener('click', (e) => {
    addSocialMachine.send("FETCH", { "provider": "google" });
  })

  let addMicrosoftBtn = document.getElementById('add-microsoft-btn');

  addMicrosoftBtn.addEventListener('click', (e) => {
    e.preventDefault();
    addSocialMachine.send("FETCH", { "provider": "microsoft" });
  })


  let addAppleBtn = document.getElementById('add-apple-btn');

  addAppleBtn.addEventListener('click', (e) => {
    e.preventDefault();
    addSocialMachine.send("FETCH", { "provider": "apple" });
  })

  let addFidoBtn = document.getElementById('add-fido-btn');
  addFidoBtn.addEventListener('click', (e) => {
    e.preventDefault();
    requestWebAuthn({}, "register", credAlertbox)
      .then((context) => {
        
        dataLoadService.send("SUBMIT");
      });
  });

  const totpModalBS = new window.bootstrap.Modal(
    document.getElementById('vv-modal-add-totp'), {});
  let addTotpBtn = document.getElementById('add-totp-btn');
  addTotpBtn.addEventListener('click', (e) => {
    //e.preventDefault();

    const totpConfig = {
      pageAlertbox: credAlertbox,
      formAlertbox: document.getElementById('add-totp-alert'),
      modalBS: totpModalBS,
      modal: document.getElementById('vv-modal-add-totp'),
      totpImg: document.getElementById('vv-modal-add-totp-img'),
      cancelBtn: document.getElementById('vv-modal-add-totp-cancel'),
      verifyBtn: document.getElementById('vv-modal-add-totp-verify'),
      codeInput: document.getElementById('vv-modal-add-totp-code'),
      form: document.getElementById('vv-modal-add-totp-form'),
      pageLoadService: dataLoadService
    }
    setupTotp(totpConfig);

  });

  function clearAlerts(selector) {
    let nodeListToClear = document.querySelectorAll(selector);
    if (nodeListToClear && nodeListToClear.length > 0) {
      Object.values(nodeListToClear).forEach(function (node) {
        vv_utils.clearalert(node);
      })
    }
  }

  function AttachShowEventsToClearUI(selector, eventname) {
    let nodeListToAddEvents = document.querySelectorAll(selector);
    if (nodeListToAddEvents && nodeListToAddEvents.length > 0) {
      Object.values(nodeListToAddEvents).forEach(function (node) {
        node.addEventListener(eventname, (event) => {
          clearAlerts(".alert");
        })
      })
    }
  }

  //Event Clear Listeners - Modals and Accordions
  AttachShowEventsToClearUI(".modal", "show.bs.modal");
  AttachShowEventsToClearUI(".accordion", "show.bs.collapse");
  AttachShowEventsToClearUI(".accordion", "hide.bs.collapse");


  ///////////////////////////  
}

export default { settingsInit_onStart };